module.exports = __webpack_public_path__ + "viaplay-logo-light-7f32a82201729c953925632b76bc9dc4.png";


//////////////////
// WEBPACK FOOTER
// ./assets/viaplay-logo-light.png
// module id = 1063
// module chunks = 0 1 2